import script from "./CodeMirror.vue?vue&type=script&setup=true&lang=js"
export * from "./CodeMirror.vue?vue&type=script&setup=true&lang=js"

import "./CodeMirror.vue?vue&type=style&index=0&id=bc6ae312&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc6ae312"]])

export default __exports__